// src/components/NotificationSimulator.tsx
import { useEffect } from "react";
import { useNotifications } from "../context/NotificationContext";
import { mockHealthCenters } from "../utils/mockData";

// Allowed Notification Types
type NotifType =
  | "battery-low"
  | "battery-medium"
  | "battery-ok"
  | "system"
  | "alert";

const NotificationSimulator: React.FC<{ user: any }> = ({ user }) => {
  const { addNotification } = useNotifications();

  useEffect(() => {
    if (!user) return;

    const interval = setInterval(() => {
      const center =
        mockHealthCenters[Math.floor(Math.random() * mockHealthCenters.length)];

      const alerts: { type: NotifType; message: string }[] = [
        {
          type: "battery-low",
          message: `Battery LOW on Device ${center.id} in ${center.district}`,
        },
        {
          type: "battery-medium",
          message: `Battery 55% on Device ${center.id} (${center.district})`,
        },
        {
          type: "battery-ok",
          message: `Device ${center.id} at ${center.name} fully charged`,
        },
        {
          type: "system",
          message: `System update available for ${center.name} in ${center.district}`,
        },
        {
          type: "alert",
          message: `New malaria-positive case at ${center.name} (${center.district})`,
        },
      ];

      const alert = alerts[Math.floor(Math.random() * alerts.length)];

      addNotification({
        id: Date.now(),
        type: alert.type,
        message: alert.message,

        // FIXED: always store valid ISO timestamps
        time: new Date().toISOString(),

        read: false,
      });
    }, 30000);

    return () => clearInterval(interval);
  }, [user, addNotification]);

  return null;
};

export default NotificationSimulator;
